import compose from 'recompose/compose';
import withState from 'recompose/withState';
import withProps from 'recompose/withProps';
import lifecycle from 'recompose/lifecycle';
import { withFormik } from 'formik';
import { buildUrl, shouldRedirectToOptions } from '../CanvasDrawers/helpers';
import withCart from '../../hocs/withCart';

export default compose(
  withCart,
  withState('isDisabled', 'setIsDisabled', false),
  withProps(props => ({
    queryParams: {
      format_identifier: props.product.variants[0].formatId,
      locale: props.product.variants[0].options.locale,
      ...props.queryParams,
    }
  })),
  withFormik({
    mapPropsToValues: props => ({
      locale: props.addToCart.form.localeOverride
    }),
    handleSubmit: (fields, { props }) => {
      props.setIsDisabled(true);
      shouldRedirectToOptions(props)
        .then(res => {
          if (res) {
            window.location = buildUrl(props, { type: 'options' });
          } else {
            props.cart.add();
          }
        });
    }
  }),
  lifecycle({
    componentDidMount() {
      const props = this.props;
      props.updateProductCustomisation(props.values);
    }
  })
);



// WEBPACK FOOTER //
// ./src/client/js/view/components/AddToCart/withAddToCart.js